async function initComparison() {
  const compareItems = getCompareProductsFromStorage();
  if (!compareItems.length) {
    console.warn("No compare products found.");
    document.getElementById("gb-comparison-table").innerHTML = "";
    return;
  }

  const specsData = await fetchSpecsFromAPI(compareItems);
  if (!specsData || Object.keys(specsData).length === 0) {
    console.error("No valid specs returned.");
    return;
  }

  window.gbComparisonData = specsData;
  renderFromCurrentSelection();
}

function renderFromCurrentSelection() {
  const items = getCompareProductsFromStorage(); 
  const data = {};
  items.forEach(({ productId }) => {
    if (window.gbComparisonData && window.gbComparisonData[productId]) {
      data[productId] = window.gbComparisonData[productId];
    }
  });

  if (Object.keys(data).length === 0) {
    document.getElementById("gb-comparison-table").innerHTML = "";
    return;
  }

  renderComparisonTable(data);
}

function getCompareProductsFromStorage() {
  const raw = localStorage.getItem("gbCompareProducts");
  let parsed = [];
  try { parsed = JSON.parse(raw) || []; } 
  catch { console.error("Failed to parse gbCompareProducts"); }

  if (!Array.isArray(parsed)) return [];

  return parsed;
}

async function fetchSpecsFromAPI(items) {
  try {
    const res = await fetch("https://gb-variant-comparison.vercel.app/api/get-product-specs-metafields", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });
    if (!res.ok) return {};

    const apiData = await res.json();
    const formatted = {};

    (apiData.results || []).forEach(item => {
      if (item?.error) return;

      const parsedSpecs = item.comparison_specs ? JSON.parse(item.comparison_specs) : {};
      const key = String(item.originalId);

      formatted[key] = {
        gid: item.productId,
        title: item.productTitle || "(Untitled Product)",
        handle: item.handle || null,
        productUrl: item.handle ? `https://gibbyselectronicsupermarket.ca/products/${item.handle}` : null,
        image: item.image || null,
        specs: parsedSpecs,
        variants: item.variants || [],
      };
    });

    return formatted;
  } catch (e) {
    console.error("Exception");
    return {};
  }
}

function formatLabel(str) {
  if (!str) return "";
  return str.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}

function renderComparisonTable(data) {
  const entries = Object.entries(data);

  const allSections = [];
  const seenSections = new Set();
  entries.forEach(([, product]) => {
    Object.keys(product.specs || {}).forEach(sectionKey => {
      if (!seenSections.has(sectionKey)) {
        allSections.push(sectionKey);
        seenSections.add(sectionKey);
      }
    });
  });

  let html = "<colgroup><col class='gb-feature-col'>";
  entries.forEach(() => (html += "<col class='gb-product-col'>"));
  html += "</colgroup><thead>";

  // Images
  html += "<tr class='gb-compare-table-img-row'><th></th>";
  entries.forEach(([, p]) => {
    html += `<th>${p.image ? `<img src="${p.image}" style="max-width: 200px" class="gb-comparison-image">` : ""}</th>`;
  });
  html += "</tr>";

  // Titles
  html += "<tr><th>Products</th>";
  entries.forEach(([, p]) => {
    html += `<th>${p.title}</th>`;
  });
  html += "</tr>";

  // Variants row
  html += `<tr class="gb-normal-row"><td>Variants</td>`;
  entries.forEach(([, p]) => {
    let cell = "-";
    if ((p.variants || []).length > 1) {
      cell = p.variants.map(v => v.title).join(", ");
    }
    html += `<td>${cell}</td>`;
  });
  html += `</tr>`;

  // Action row
  html += "<tr class='gb-actions-row'><th></th>";
  entries.forEach(([productId, p]) => {
    const url = p.productUrl || "https://gibbyselectronicsupermarket.ca/";
    html += `
      <th>
        <a href="${url}" target="_blank" type="button"
           class="btn btn--primary w-full gb-compare-page-btn js-quick-add"
           data-product-id="${productId}">
          Visit Product
        </a>
        <button type="button" class="btn btn--secondary w-full gb-compare-page-btn gb-remove-from-compare-btn"
                data-product-id="${productId}">
          Remove from Comparison
        </button>
      </th>
    `;
  });
  html += "</tr>";

  html += "</thead><tbody>";

  // Body rows
  allSections.forEach(sectionKey => {
    let isNested = false;
    entries.forEach(([, p]) => {
      const val = p.specs?.[sectionKey];
      if (typeof val === "object" && val !== null) isNested = true;
    });

    if (sectionKey === "Dimensions" || sectionKey === "Weight") return;

    if (isNested) {
      html += `<tr class="gb-subheading-row"><td>${formatLabel(sectionKey)}</td>`;
      entries.forEach(() => { html += `<td></td>`; });
      html += `</tr>`;

      const subKeys = [];
      const seenSubKeys = new Set();
      entries.forEach(([, p]) => {
        const val = p.specs?.[sectionKey];
        if (typeof val === "object" && val) {
          Object.keys(val).forEach(subKey => {
            if (!seenSubKeys.has(subKey)) {
              subKeys.push(subKey);
              seenSubKeys.add(subKey);
            }
          });
        }
      });

      subKeys.forEach(subKey => {
        if (subKey === "Dimensions") {
          html += `<tr class="gb-child-row"><td>${formatLabel(subKey)}</td>`;
          entries.forEach(([, p]) => {
            const dims = p.specs?.[sectionKey]?.[subKey] || {};
            const normalize = v => (v === "" || v == null ? null : v);

            const w  = normalize(dims["Width Number"]  ?? dims["Width"]);
            const wu = normalize(dims["Width Unit"]);
            const h  = normalize(dims["Height Number"] ?? dims["Height"]);
            const hu = normalize(dims["Height Unit"]);
            const d  = normalize(dims["Depth Number"]  ?? dims["Depth"]);
            const du = normalize(dims["Depth Unit"]);

            const parts = [];
            if (w || wu) parts.push(`${w ?? "-"} ${wu ?? ""} (W)`.trim());
            if (h || hu) parts.push(`${h ?? "-"} ${hu ?? ""} (H)`.trim());
            if (d || du) parts.push(`${d ?? "-"} ${du ?? ""} (D)`.trim());

            const txt = parts.length > 0 ? parts.join(" x ") : "-";
            html += `<td>${txt}</td>`;
          });
          html += `</tr>`;
        } else if (subKey === "Weight") {
          html += `<tr class="gb-child-row"><td>${formatLabel(subKey)}</td>`;
          entries.forEach(([, p]) => {
            const wt = p.specs?.[sectionKey]?.[subKey];
            let txt = "-";

            if (wt && typeof wt === "object") {
              const normalize = v => (v === "" || v == null ? null : v);
              const num  = normalize(wt["Weight Number"] ?? wt["Number"] ?? wt["value"]);
              const unit = normalize(wt["Weight Unit"]   ?? wt["Unit"]);
              if (num || unit) {
                txt = `${num ?? "-"} ${unit ?? ""}`.trim();
              }
            } else if (wt != null && wt !== "") {
              txt = `${wt}`;
            }

            html += `<td>${txt}</td>`;
          });
          html += `</tr>`;
        } else {
          html += `<tr class="gb-child-row"><td>${formatLabel(subKey)}</td>`;
          entries.forEach(([, p]) => {
            const value = p.specs?.[sectionKey]?.[subKey] ?? "-";
            html += `<td>${value}</td>`;
          });
          html += `</tr>`;
        }
      });

    } else {
      html += `<tr class="gb-normal-row"><td>${formatLabel(sectionKey)}</td>`;
      entries.forEach(([, p]) => {
        const value = p.specs?.[sectionKey] ?? "-";
        html += `<td>${value}</td>`;
      });
      html += `</tr>`;
    }
  });

  const table = document.getElementById("gb-comparison-table");
  if (!table) return;
  table.innerHTML = html;
}

// --- Remove + Clear with fallback --- //
document.addEventListener("DOMContentLoaded", () => {
  initComparison();

  const table = document.getElementById("gb-comparison-table");
  const clearBtn = document.querySelector(".gb-clear-compare-btn");

  // Remove button
  if (table) {
    table.addEventListener("click", (e) => {
      const btn = e.target.closest(".gb-remove-from-compare-btn");
      if (!btn) return;

      let productId = btn.getAttribute("data-product-id");
      if (!productId) return;

      // normalize GID to plain numeric ID
      productId = productId.replace("gid://shopify/Product/", "");

      if (window.gbCompareManager && typeof window.gbCompareManager.removeItem === "function") {
        window.gbCompareManager.removeItem({ productId });
      } else {
        const key = "gbCompareProducts";
        const raw = localStorage.getItem(key);
        const arr = raw ? JSON.parse(raw) : [];
        const next = arr.filter(x => String(x.productId) !== String(productId));
        localStorage.setItem(key, JSON.stringify(next));
      }

      renderFromCurrentSelection();
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      localStorage.removeItem("gbCompareProducts");
      if (window.gbCompareManager && typeof window.gbCompareManager.clearAll === "function") {
        window.gbCompareManager.clearAll();
      }
      renderFromCurrentSelection();
    });
  }
});